const generateFileName = (folder: string, name: string, type: string): string => {
  if (process.env["NODE_ENV"] === "production") {
    return `${folder}/${name}-${Math.random().toString(36).slice(2)}.${type.split("/").pop()}`;
  }

  return `development/${folder}/${name}-${Math.random().toString(36).slice(2)}.${type.split("/").pop()}`;
};

export { generateFileName };
